import React, { useState } from "react";
import axios from "axios";

const ConsultationForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    preferredDate: "",
    hour: "",
    minute: "",
    period: "",
    consultationType: "",
    inquiryDescription: "",
    heardFrom: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Convert hour, minute, and period to 24-hour time
    const hour24 =
      formData.period === "PM" && formData.hour !== "12"
        ? parseInt(formData.hour, 10) + 12
        : formData.period === "AM" && formData.hour === "12"
        ? 0
        : formData.hour;

    // Combine date and time into ISO 8601 format
    const formattedDateTime = new Date(
      `${formData.preferredDate}T${hour24}:${formData.minute}:00.000+00:00`
    ).toISOString();

    const submissionData = {
      ...formData,
      preferredDateTime: formattedDateTime, // Attach the formatted date-time
    };

    try {
      const response = await axios.post(
        "https://mirai-server.vercel.app/upload-client-data",
        submissionData
      );
      alert(response.data.message || "Application submitted successfully!");

      // Reset the form state after successful submission
      setFormData({
        fullName: "",
        email: "",
        phone: "",
        preferredDate: "",
        hour: "",
        minute: "",
        period: "",
        consultationType: "",
        inquiryDescription: "",
        heardFrom: "",
      });
    } catch (error) {
      console.error(
        "Error submitting form:",
        error.response?.data || error.message
      );
      alert("Failed to submit the form. Please try again.");
    }
  };
  
  return (
    <form class="w-full" onSubmit={handleSubmit}>
      <div className="flex lg:flex-row sm:flex-col justify-between gap-5 w-full">
        <div className="w-full">
          <div class="relative z-0 w-full mb-5 group">
            <input
              type="text"
              value={formData.fullName}
              onChange={handleChange}
              name="fullName"
              id="fullName"
              class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=""
              required
            />
            <label
              for="fullName"
              name="fullName"
              class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Full Name
            </label>
          </div>
          <div class="relative z-0 w-full mb-5 group">
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
              required
            />
            <label
              for="email"
              class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Email address
            </label>
          </div>
          <div class="relative z-0 w-full mb-5 group">
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              // pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
              id="phone"
              class="block py-2.5 px-0 w-full lg:text-2xl sm:text-md font-jost text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
              required
            />
            <label
              for="phone"
              class="peer-focus:font-medium absolute lg:text-2xl sm:text-md font-jost text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Phone number (+880-16299-64630)
            </label>
          </div>

          <div className="flex flex-col gap-2 ">
            <label className="lg:text-2xl sm:text-md font-jost text-gray-500">
              Preferred Date:
            </label>
            <input
              type="date"
              name="preferredDate"
              className="rounded lg:text-2xl sm:text-md font-jost text-gray-500 border border-gary-500 bg-transparent bg-transparent"
              value={formData.preferredDate}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col gap-2 mt-5">
  <label className="lg:text-2xl sm:text-md font-jost text-gray-500">
    Preferred Time:
  </label>
  <div className="flex flex-col gap-2 mt-5">
  <label className="lg:text-2xl sm:text-md font-jost text-gray-500">
    Preferred Time:
  </label>
  <div className="flex gap-2">
    {/* Hour Selector */}
    <select
      name="hour"
      className="rounded lg:text-2xl sm:text-md font-jost text-gray-500 border border-gray-500 bg-transparent"
      value={formData.hour}
      onChange={handleChange}
      required
    >
      <option value="">Hour</option>
      {[...Array(12)].map((_, i) => {
        const hour = (i + 1).toString().padStart(2, "0");
        return (
          <option key={hour} value={hour}>
            {hour}
          </option>
        );
      })}
    </select>

    {/* Minute Selector */}
    <select
      name="minute"
      className="rounded lg:text-2xl sm:text-md font-jost text-gray-500 border border-gray-500 bg-transparent"
      value={formData.minute}
      onChange={handleChange}
      required
    >
      <option value="">Minute</option>
      {["00", "15", "30", "45"].map((minute) => (
        <option key={minute} value={minute}>
          {minute}
        </option>
      ))}
    </select>

    {/* Period Selector */}
    <select
      name="period"
      className="rounded lg:text-2xl sm:text-md font-jost text-gray-500 border border-gray-500 bg-transparent"
      value={formData.period}
      onChange={handleChange}
      required
    >
      <option value="">AM/PM</option>
      <option value="AM">AM</option>
      <option value="PM">PM</option>
    </select>
  </div>
</div>

</div>

          <div className="flex flex-col gap-2 mt-5">
            <label className="lg:text-2xl sm:text-md font-jost text-gray-500">
              Type of Consultation:
            </label>
            <select
              name="consultationType"
              className="rounded lg:text-2xl sm:text-md font-jost text-gray-500 border border-gary-500 bg-transparent"
              value={formData.consultationType}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="Legal Services">Legal Services</option>
              <option value="HR Consulting">HR Consulting</option>
              <option value="Tax Planning & Consulting">
                Tax Planning & Consulting
              </option>
              <option value="Accounting & Consulting Services">
                Accounting & Consulting Services
              </option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
        <div className="w-full">
          
          <div className="flex flex-col gap-2 mt-5">
            <label className="lg:text-2xl sm:text-md font-jost text-gray-500">
              Inquiry Description:
            </label>
            <textarea
              className="rounded lg:text-2xl sm:text-md lg:h-56 sm:h-32 font-jost text-gray-500 border border-gary-500 bg-transparent"
              name="inquiryDescription"
              value={formData.inquiryDescription}
              onChange={handleChange}
              placeholder="type..."
              required
            ></textarea>
          </div>
          <div>
            <h3 className="lg:text-2xl sm:text-md font-jost text-gray-500 mt-5">
              How Did You Hear About Us?
            </h3>
            <div className="mt-2 flex flex-row items-center">
              <input
                type="radio"
                name="heardFrom"
                value="Referral"
                onChange={handleChange}
                checked={formData.heardFrom === "Referral"}
              />
              <label className="font-jost text-lg ml-2 ">Referral</label>
            </div>
            <div className="mt-2 flex flex-row items-center">
              <input
                type="radio"
                name="heardFrom"
                value="Social Media"
                onChange={handleChange}
                checked={formData.heardFrom === "Social Media"}
              />{" "}
              <label className="font-jost text-lg ml-2 ">Social Media</label>
            </div>
            <div className="mt-2 flex flex-row items-center">
              <input
                type="radio"
                name="heardFrom"
                value="Website"
                onChange={handleChange}
                checked={formData.heardFrom === "Website"}
              />{" "}
              <label className="font-jost text-lg ml-2 ">Website</label>
            </div>
            <div className="mt-2 flex flex-row items-center">
              <input
                type="radio"
                name="heardFrom"
                value="Other"
                onChange={handleChange}
                checked={formData.heardFrom === "Other"}
              />{" "}
              <label className="font-jost text-lg ml-2 ">Other</label>
            </div>
          </div>
        </div>
      </div>

      <button
        className="px-6 py-2 rounded backGroundCustom mt-5 text-white font-jost"
        type="submit"
      >
        Submit
      </button>
    </form>
  );
};

export default ConsultationForm;
